<ng-container *ngIf="HasRequiredPermissions">
  <div class="bg-white p-6 rounded-lg shadow w-full max-w-none" [class.my-8]="!isNested" [class.my-4]="isNested">
    <div class="mb-6">
      <h1 class="text-lg font-medium text-gray-700 mb-4" data-testid="list-title">
        {{ `entities.${entityMetaData.EntityName.toLowerCase()}.pluralName` | translate }} ({{ totalSeen }}/{{
        listView()?.entities()?.total }})
      </h1>
    </div>
    <app-list-view [entityType]="ComponentEntityClass"
      [contextMenuItems]="contextMenuItems"
      [showActions]="true"
      [canEdit]="canEdit.bind(this)"
      (entitySelected)="selectSingleItem($event)"
      (editAction)="editSelectedItem($event)"
      (deleteAction)="deleteSelectedItem($event)"
      [dismissEntity]="dismissEntityState.bind(this)"
      [onDismissAdded]="dismissEntityState.bind(this)"
      [onRowDismiss]="handleRowDismiss.bind(this)"
      [pagination]="{
                          enabled: true,
                          pageLengths: [5, 10, 20, 50, 100, 300],
                          defaultPageLength: 5,
                          searchColumns: null,
                          sortableColumns: null
                        }" [paginatorType]="'button'"
      [showHeader]="false"
      (createButtonClick)="openCreateModal()">
      <!-- Colonne FullName -->
      <app-list-table-column key="fullName" title="{{ 'entities.trucker.propreties.fullName' | translate }}" type="text"
        [sortable]="true" align="left"></app-list-table-column>
      <app-list-table-column key="companyName" title="{{ 'entities.trucker.propreties.companyName' | translate }}"
        type="text" [sortable]="true" align="left"></app-list-table-column>

      <!-- Colonne Status -->
      <app-list-table-column key="status" title="{{ 'entities.trucker.propreties.status' | translate }}" type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.status)" [lookupData]="truckerStatusLookup()" [Skin]="Skin"
            [isEditMode]="true" (statusChange)="updateEntityProperty(entity, 'status', $event)">
          </app-reactive-badge>
        </ng-template>
      </app-list-table-column>

      <!-- Colonne Validated -->
      <app-list-table-column key="validated" title="{{ 'entities.trucker.propreties.validated' | translate }}"
        type="custom">
        <ng-template #customTemplate let-entity>
          <app-reactive-badge [status]="$safeNavigationMigration(entity?.validated)" [lookupData]="truckerValidationStateLookup()" [Skin]="Skin"
            [isEditMode]="true" (statusChange)="updateEntityProperty(entity, 'validated', $event)">
          </app-reactive-badge>
        </ng-template>
      </app-list-table-column>
    </app-list-view>

    <div class="fixed top-0 right-0 h-full z-50 min-w-[350px]"
      [style.width.px]="currentWidth()"
      [hidden]="!isModalOpen()">

      <!-- Poignee interactive (invisible avant le survol)  -->
      <div class="absolute left-0 top-0 h-full w-2 hover:w-3 hover:bg-gray-600 hover:shadow-md cursor-[ew-resize] transition-all z-[999]"
        (mousedown)="startResize($event)">
      </div>
      <div class="bg-white rounded-lg shadow-xl p-1 h-full">
        <app-trucker-detail #truckerDetail
          [isModal]="true"
          [dataService]="dataService"
          (closeModal)="closeModal($event)"
          (itemSaved)="onItemUpdated($event)"
          (databaseUpdated)="closeModal(true)"
          [EntityInstance]="selectedItem()"
          [fkPointOfServiceId]="fkPointOfServiceId">
        </app-trucker-detail>
      </div>
    </div>
  </div>


</ng-container>